import { produce } from 'immer';

export const createKareNote = (set) => ({
  serviceParams: {},
  addServiceParams: (newParams) =>
    set(
      produce(({ kareNote }) => {
        kareNote.serviceParams = newParams;
      }),
    ),
});

